import i18n from '@/lang/i18n'
import { AgGridColumnType, ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import { ColDef } from '@ag-grid-enterprise/all-modules'

export const clinicalPatientGridDetailColumnDefs: (ColDef | ExportedColDef | ExportedColGroupDef)[] = [
    {
        headerName: i18n.tc('global.requestNumber'),
        field: 'label',
        type: AgGridColumnType.TEXT
    },
    {
        headerName: i18n.tc('grid.detail.casStatusId'),
        field: 'status',
        type: AgGridColumnType.COMMON_REQUEST_STATUS
    },
    {
        headerName: i18n.tc('grid.detail.casRequestDate'),
        field: 'requestDate',
        type: AgGridColumnType.DATETIME
    },
    {
        headerName: i18n.tc('grid.detail.priority'),
        colId: 'priority.level',
        field: 'priority',
        type: AgGridColumnType.PRIORITY
    },
    {
        headerName: i18n.tc('grid.detail.depPhysName'),
        field: 'physicianDepartment.name',
        type: AgGridColumnType.TEXT
    },
    {
        headerName: i18n.tc('grid.detail.cenPhysName'),
        field: 'physicianDepartment.center.name',
        type: AgGridColumnType.TEXT
    },
    {
        headerName: i18n.tc('grid.detail.petPhysName'),
        field: 'physicianPetitioner.fullName',
        type: AgGridColumnType.TEXT
    },
    {
        headerName: i18n.tc('grid.detail.casRegistrationDate'),
        field: 'caseStudy.casRegistrationDate',
        type: AgGridColumnType.DATETIME
    },
    {
        headerName: i18n.tc('grid.detail.casInformedDate'),
        field: 'caseStudy.casInformedDate',
        type: AgGridColumnType.DATETIME
    },
    {
        headerName: i18n.tc('grid.detail.casValidationDate'),
        field: 'caseStudy.casValidationDate',
        type: AgGridColumnType.DATETIME
    },
    {
        headerName: i18n.tc('grid.detail.patName'),
        field: 'caseStudy.pathologist.fullName',
        type: AgGridColumnType.TEXT
    },
    {
        headerName: i18n.tc('grid.detail.labName'),
        field: 'laboratory.labName',
        type: AgGridColumnType.TEXT
    }
]
